module.exports = __webpack_public_path__ + "static/news-e451deaf21fc39d0529a6f5aa032c41a.jpg";